/**
 * Created by jv on 06/02/2017.
 */
const utils = require("Sources/utils/utils");
const Contact = require("Sources/models/contact");

module.exports = class OrderInfo
{
  constructor(options)
  {
    options = utils.isNotNull(options) ? options : {};

    this.differentFacContact = utils.isBoolean(options["different-fac-contact"]) ? options["different-fac-contact"] : true;
    this.differentLevContact = utils.isBoolean(options["different-lev-contact"]) ? options["different-lev-contact"] : true;

    this.vat = options.vat;
    this.companyNumber = options["company-number"];
    this.remark = options.remark;
    this.purchaseOrderNumber = options["bestelbon-number"];

    this.generateInvoice = utils.isBoolean(options["consumer-generate-invoice"]) ? options["consumer-generate-invoice"] : false;

    this.contactCon = options["contact-con"];
    this.contactFac = options["contact-fac"];
    this.contactLev = options["contact-lev"];

    this.involvedPersonList = utils.isNotNull(options["involved-person-list"]) ? options["involved-person-list"] : [];
  };

  set contactCon(contact)
  {
    this._contactCon = new Contact(contact);
  }

  get contactCon()
  {
    return this._contactCon;
  }

  set contactFac(contact)
  {
    this._contactFac = new Contact(contact);
  }

  get contactFac()
  {
    return this._contactFac;
  }

  set contactLev(contact)
  {
    this._contactLev = new Contact(contact);
  }

  get contactLev()
  {
    return this._contactLev;
  }
};



// WEBPACK FOOTER //
// ./app/js/models/store/order-info.js